import { ShippingStatus } from '@40seas/entities/shipping';
import { EnumColor } from '@40seas/frontend/common/providers';

export const shippingStatusColorMapping = {
    [ShippingStatus.Valid]: 'success',
    [ShippingStatus.Invalid]: 'error',
    [ShippingStatus.Pending]: 'default',
} as { [key in ShippingStatus]: EnumColor };
